export const de = {
  // topnav
  Search: 'Suche',
  FullScreen: 'Vollbild',
  Refresh: 'Aktualisieren',
  selected: 'ausgewählt',

  LogIn: 'Anmelden',
  LogOut: 'Abmelden',
  SignUp: 'Registrierung',
  SignIn: 'Anmeldung',

  // sidenav
  Alerts: 'Alarm',
  Heartbeats: 'Lebenszeichen',
  Users: 'Nutzer',
  Groups: 'Gruppen',
  Customers: 'Kunden',
  Blackouts: 'Blackouts',
  Permissions: 'Berechtigungen',
  APIKeys: 'API Keys',
  Labels: 'Labels',
  Reports: 'Berichte',
  More: 'Mehr',
  Settings: 'Einstellungen',
  Help: 'Hilfe',
  About: 'Über',
  AedifionHome: 'aedifion Home',
  AedifionIO: 'aedifion .io',
  AedifionDocs: 'Dokumentation',
  ProjectNotAllowed: 'Sie haben keinen Zugriff auf das Projekt dieses Alarms. Bitte wenden Sie sich an Ihren Administrator, um Zugriff zu diesem Projekt zu erhalten.',
  Project: 'Projekt',
  NoProjectAssigned: 'Diesem Alarm ist kein Projekt zugeordnet, daher wird kein Graph dargestellt.',
  TimeseriesError: 'Es konnten keine Zeitreihendaten zum Datenpunkt des Alarms geladen werden.',
  NoDatapointAssigned: 'Dieser Alarm ist keinem Datenpunkt zugewiesen, daher wird kein Graph dargestellt.',

  // more
  ChooseDisplayDensity: 'Wähle Anzeigedichte',
  DisplayDensity: 'Anzeigedichte',
  Comfortable: 'Komfortabel',
  Compact: 'Kompakt',
  Panel: 'Panel',
  Hide: 'Verstecken',
  Show: 'Zeigen',
  DownloadAsCsv: 'Download als CSV',

  // Groups store
  UserAddedGroup: 'Nutzer zu Gruppe hinzugefügt.',
  UserRemovedGroup: 'Nutzer von Gruppe gelöscht.',

  // Preferences store
  SettingsSaved: 'Einstellungen gespeichert.',
  SettingsReset: 'Einstellungen zurückgesetzt.',
  SettingsError: 'Konnte Nutzereinstellungn nicht empfangen.',

  // Users store
  UserStatusSaved: 'Nutzerstatus gespeichert.',
  EmailSaved: 'E-Mail verifiziert.',

  // statuses
  Open: 'Offen',
  Assign: 'Zugewiesen',
  Ack: 'Bestätigt',
  Shelved: 'Aufgeschoben',
  Blackout: 'Blackout',
  Closed: 'Geschlossen',
  Expired: 'Abgelaufen',
  Unknown: 'Unbekannt',
  NotValid: 'Nicht gültig',

  // operator actions
  Open: 'Öffen',
  Assign: 'Zuweisen',
  Ack: 'Bestätigen',
  Unack: 'Unack',
  Shelve: 'Aufschieben',
  Unshelve: 'Unshelve',
  Close: 'Schließen',
  Watch: 'Beobachten',
  Unwatch: 'Nicht beobachten',
  AddNote: 'Notiz hinzufügen',
  Delete: 'Löschen',

  // Alert actions
  TextIsRequired: 'Text ist erforderlich',
  TextMustBeLessThan: 'Text muss mindestens',
  characters: 'Zeichen lang sein',

  // Alert detail
  AlertId: 'Alarm ID',
  LastReceiveAlertId: 'Letzte empfangene Alert ID',
  CreateTime: 'Erstellzeit',
  ReceiveTime: 'Empfangszeit',
  LastReceiveTime: 'Letzte Empfangszeit',
  Customer: 'Kunde',
  Service: 'Service',
  Environment: 'Umgebung',
  Resource: 'Ressource',
  Event: 'Ereignis',
  Correlate: 'Korrelation',
  Group: 'Gruppe',
  Severity: 'Schweregrad',
  Status: 'Status',
  Value: 'Wert',
  Text: 'Text',
  TrendIndication: 'Trendindikator',
  Timeout: 'Zeitüberschreitung',
  Type: 'Typ',
  DuplicateCount: 'Duplikatzähler',
  Repeat: 'Widerholung',
  Origin: 'Herkunft',
  Tags: 'Tags',
  Attributes: 'Attribute',
  History: 'Historie',
  Data: 'Daten',

  Details: 'Details',
  addedNoteOn: 'Notiz hinzugefügt an',
  by: 'von',

  // Alert history
  UpdateTime: 'Aktualisierungszeit',
  Updated: 'Aktualisiert',
  User: 'Nutzer',

  // Alert list
  Loading: 'Lädt',
  NoDataAvailable: 'Keine Daten verfügbar',
  ALL: 'ALLE',
  Description: 'Beschreibung',
  Attribute: 'Attribut',
  TimeoutLeft: 'Timeout',
  Dupl: 'Dupl.',
  PrevSeverity: 'Vorh. Schweregrad',
  LastReceiveId: 'Letze empf. ID',
  LastNote: 'Letzte Notiz',

  // Alert list filter
  Filters: 'Filter',
  FilterDescription: 'Ergebnisse durch Textsuche filtern',
  AllStatuses: 'Alle Status',
  StatusDescription: 'Wähle einen oder mehrere Status',
  AllCustomers: 'Alle Kunden',
  CustomerDescription: 'Wähle einen oder mehrere Kunden',
  AllServices: 'Alle services',
  ServiceDescription: 'Wähle einen oder mehrere Services',
  AllGroups: 'Alle Gruppen',
  GroupDescription: 'Wähle einen oder mehrere Gruppen',

  Latest: 'Letzte',
  Hour: '1 Stunde',
  SixHours: '6 Stunden',
  TwelveHours: '12 Stunden',
  SelectRange: 'Wähle Zeitraum',

  DateTime: 'Datum/Zeit',
  StartDate: 'Startdatum',
  EndDate: 'Enddatum',
  Time: 'Zeit',
  Apply: 'Anwenden',
  Reset: 'Zurücksetzen',

  // API keys
  APIKey: 'API Key',
  Search: 'Suche',
  Customer: 'Kunde',
  Scopes: 'Bereiche',
  Expires: 'Ablauf',
  Active: 'Aktiv',
  Expired: 'Abgelaufen',
  Slow: 'Langsam',

  User: 'Nutzer',
  LastUsed: 'Zuletzt benutzt',
  Actions: 'Aktionen',

  Copy: 'Kopieren',
  Copied: 'Kopiert!',
  NewApiKey: 'Neuer API Schlüssel',
  EditApiKey: 'Bearbeite API Schlüssel',

  // Blackouts
  ChooseService: 'Wähle einen oder mehrere Services',
  Start: 'Start',
  End: 'Ende',
  Created: 'Erstellt',
  Reason: 'Ursache',
  NewBlackout: 'Neuer Blackout',
  EditBlackout: 'Bearbeite Blackout',

  // Customers
  LookUp: 'Nachschlagen',
  LookUpDescription: 'Nutze Login, Keycloak Rolle, GitHub org, GitLab Gruppe oder E-Mail-Domain',
  NewCustomer: 'Neuer Kunde',
  EditCustomer: 'Bearbeite Kunde',

  // Groups
  AddRemoveUsers: 'Erstellen/Lösche Nutzer',
  Addusers: 'Erstellen Nutzer',
  UsersInGroup: 'Nutzer in Gruppe',
  NumberUsers: 'Nutzeranzahl',
  NewGroup: 'Neue Gruppe',
  EditGroup: 'Bearbeite Gruppe',

  // Heartbeats
  Latency: 'Latenz',
  Since: 'Seit',

  // Manifest
  API: 'API',
  OpenGitHub: 'Öffne in GitHub',
  WebUI: 'Web UI',
  Build: 'Build',
  Date: 'Datum',
  GitRevision: 'Git Revision',
  APIEndpoint: 'API Endpoint',

  // Perms
  Role: 'Rolle',
  Scope: 'Bereich',
  SystemRole: 'Systemrolle',
  NewPermission: 'Nutzerberechtigung',
  EditPermission: 'Bearbeite Berechtigung',

  // Preferences
  ApplicationSettings: 'Applikationseinstellungen',
  DarkTheme: 'Dunkles Theme',
  PlaySounds: 'Benachrichtigungstöne abspielen',
  LanguageSettings: 'Spracheinstellungen',
  Languages: 'Sprachen',
  English: 'Englisch',
  French: 'Französisch',
  German: 'Deutsch',
  DateTimeSettings: 'Datums- und Zeiteinstellungen',
  LongDate: 'Langes Datumsformat',
  MediumDate: 'Mittleres Datumsformat',
  ShortTime: 'Kurzes Zeitformat',
  DisplayMode: 'Anzeigemodus',
  UseLocal: 'Nutze lokales Datum & Zeit',
  UseUTC: 'Nutze Coordinated Universal Time (UTC)',
  AlertSettings: 'Meldungseinstellungen',
  PageRows: 'Zeilen pro Seite',
  rows: 'Zeilen',
  RefreshInterval: 'Aktualisierungsinterval',
  seconds: 'Sekunden',
  ShelveTimeout: 'Shelve timeout',
  hours: 'Stunden',

  // Profile Me
  EmailVerified: 'E-Mail verifiziert',
  EmailNotVerified: 'E-Mail nicht verifiziert',
  Customers: 'Kunden',
  Organizations: 'Organisationen',
  Groups: 'Gruppen',
  Roles: 'Rollen',
  Scopes: 'Bereiche',
  others: 'sonstiges',

  // Status
  LastUpdate: 'Letztes Update',
  Uptime: 'Betriebszeit',
  Metric: 'Metrisch',
  Type: 'Typ',
  Name: 'Name',
  Value: 'Wert',
  AvgTime: 'Durchschn. Zeit',

  // Users
  Active: 'Aktiv',
  Inactive: 'Inaktiv',
  Login: 'Login',
  Email: 'E-Mail',
  Verified: 'Verifiziert',
  Comment: 'Kommentar',
  VerifiedOrNot: 'Verifiziert?',
  LastLogin: 'Letzter Login',
  NewUser: 'Neuer Nutzer',
  EditUser: 'Bearbeite Nutzer',

  // Reports
  TopFlapping: 'Top 10 Flapping',
  TopFlappingDescription: 'Chattering and fleeting alert sources that have generated the most number of alert severity changes.',
  TopOffenders: 'Top 10 Offenders',
  TopOffendersDescription: 'Frequently occurring alert sources that have generated the most number of alerts and alert duplicates.',
  TopStanding: 'Top 10 Standing',
  TopStandingDescription: 'Stale alert sources that have active alerts for a prolonged duration.',
  
  Count: 'Anzahl',
  DuplCount: 'Dupl. Anzahl',
  Services: 'Services',
  Resources: 'Ressourcen',

  // User Confirm
  Thanks: 'Danke!',
  YouCanNowLogin1: 'Sie können sich jetzt',
  YouCanNowLogin2: 'anmelden.',
  EmailConfirmFailed: 'Entschuldigung, es gab ein Problem bei der Verifizierung Ihrer E-Mail-Adresse',
  TryAgain: 'Bitte erneut versuchen',

  // User Forgot
  ResetLink: 'E-Mail eingeben um einen Rücksetzungs-Link zu erhalten',
  AlreadyHaveAccount: 'Haben sie bereits ein Konto?',
  CheckEmail: 'Überprüfen Sie Ihre E-Mail auf einen Rücksetzungs-Link...',
  ReturnSignIn: 'Zurück zur Anmeldung',
  ResetEmailSent: 'Rücksetzungs-Mail erfolgreich gesendet!',

  // User Login
  LoginToContinue: 'Bei Alerta anmelden um fortzufahren',
  Username: 'Nutzername',
  Password: 'Passwort',
  CreateAccount: 'Account erstellen',
  ForgotPassword: 'Passwort vergessen?',
  UnspecifiedProblem: 'Entschuldigung, es gab ein Problem',
  AuthWith: 'Authentifiziere mit',
  AuthInProgress: 'Authentifiziere...',
  AuthNotPossible: 'Entschuldigung, Authentifizierung nicht möglich',
  AuthProviderUnknown: 'Unbekannter Authentifizierungsanbieter',

  // User Logout
  LoggedOut: 'Sie wurden abgemeldet.',

  // User Reset
  ChooseNewPassword: 'Neues Passwort auswählen',
  ConfirmPassword: 'Passwort bestätigen',
  ResetPassword: 'Passwort zurücksetzen',

  // User Signup
  CreateAlertaAccount: 'Erstellen Sie Ihr Alerta-Konto',
  SignUpNotAvailable: 'Entschuldigung, die Anmeldung ist derzeit nicht möglich',
  FullName: 'Voller Name',
  Min6Char: 'Min. 6 Zeichen',
  PasswordNotMatch: 'Passwörter stimmen nicht überein',

  // Labels
  scope: 'Bereich',
  role: 'Rolle',
  customer: 'Kunde',
  group: 'Gruppe',

  // General
  ConfirmDelete: 'Sind Sie sicher, dass Sie diesen Punkt löschen möchten?',
  Error: 'Fehler',
  Send: 'Senden',
  Required: 'Erforderlich',
  Cancel: 'Abbrechen',
  Save: 'Speichern',
  NoDisplay: 'Entschuldigung, hier gibt es nichts zu sehen :(',
  SearchNoResult1: 'Ihre Suche nach ',
  SearchNoResult2: 'hat nichts gefunden.',
  OK: 'OK',

  // ENDS.
}
